/**
 * @ngdoc service
 * @description RegistrationService holds state for the registration family of controllers for ecourses. It delegates the resgirtation to the ecourses factory but provides the controller with useful information.
 * @param Ecourses
 * @param $state
 * @param Alerts
 * @param $timeout
 * @param $q
 * @param $interpolate
 * @param User
 * @constructor
 * @param $rootScope
 * @param environment
 */
export default function RegistrationService(Ecourses, $state, Alerts, $timeout, $q, $interpolate, User, $rootScope, environment) {
  'ngInject';

  /**
   * @description Some messages.
   */
  const MESSAGES = {
    success: {
      purchase: "Your registration for {{ecourse.title}} was successful. Thank you!",
      redeem: "Your redemption of {{ecourse.title}} was successful. Awesome!",
      gift: "Your gift of {{ecourse.title}} was successful. You are so generous!"
    }
  };

  /**
   * @name formData
   * @description Holds form state.
   * @type {{}}
   */
  this.formData = {};

  /**
   * @name message
   * @description Just an interpolation wrapper
   * @param msg
   * @param context
   * @returns {*}
   */
  function message(msg, context) {
    return $interpolate(msg)(context);
  }

  /**
   * @name register
   * @description Delegates the registration to the factory while dryly performing actions on status events for the registration family of controllers.
   * @param type
   * @param ecourse
   * @returns {*} Promise
   */
  this.register = (type, ecourse) => {
    let defer = $q.defer();
    //Success actions
    function registrationSuccess(successResponse) {
      //Wait a bit then redirect.
      //if (environment.name === 'Production') {
        window.fbq('track', environment.social.facebook.pixels.conversion, {
          value: successResponse.transaction.amountCharged,
          currency: 'USD'
        });
        window.fbq('track', 'Purchase');
      //}
      let routeQuery = {purchaseType: successResponse.transaction.purchaseType, slug: ecourse.slug};
      $timeout(()=> {
        $state.go('app.ecourse.overview', routeQuery, {reload: true});
      }, 500);
      Alerts.add({
        type: 'success',
        message: message(MESSAGES.success[type], {ecourse})
      });
      defer.resolve();
    }

    function registrationError(data) {
      if (data.errors.userCreated) {
        User.getUser();
      }
      //Alert errors are special.
      if (data.alert) {
        //Show the alert
        Alerts.add({
          type: 'danger',
          message: data.alert
        });
      }
      //Heave the original errors to the controller.
      defer.reject(data.errors);
    }

    //Call register in the factory.
    Ecourses.register(type, ecourse, this.formData).then(
      registrationSuccess,
      registrationError
    );

    //Promise to the caller
    return defer.promise;
  };

  this.planFree = (allowDiscount = true) => {
    let credit;
    if (this.formData.card) {
      credit = this.formData.card.useAccountCredit;
    }
    return this.planPrice(credit, allowDiscount) <= 0 ? true : false;
  };

  this.planPrice = (useCredit, allowDiscount = true) => {
    if(this.formData.plan) {
      let plan = this.formData.plan,
        price = plan.price;
      if (plan.discount && allowDiscount) {
        price = price - plan.discount;
      }
      if (useCredit) {
        price = price - User.currentUser.accountCredit;
      }
      return Math.max(0, price);
    }
  };

  this.generateScreenName = (models) => {
    let [fName = '',lName = ''] = models,
      rand = Math.floor(Math.random() * (100 - 0)),
      last = lName.length > 0 ? `-${lName.charAt(0)}${rand}` : '';
    return `${fName}${last}`;
  };


  //I put this at the bottom because it is huge :)
  this.states = {
    "": "State",
    "NON-US": "Non US",
    "AL": "Alabama",
    "AK": "Alaska",
    "AZ": "Arizona",
    "AR": "Arkansas",
    "CA": "California",
    "CO": "Colorado",
    "CT": "Connecticut",
    "DE": "Delaware",
    "DC": "District Of Columbia",
    "FL": "Florida",
    "GA": "Georgia",
    "HI": "Hawaii",
    "ID": "Idaho",
    "IL": "Illinois",
    "IN": "Indiana",
    "IA": "Iowa",
    "KS": "Kansas",
    "KY": "Kentucky",
    "LA": "Louisiana",
    "ME": "Maine",
    "MD": "Maryland",
    "MA": "Massachusetts",
    "MI": "Michigan",
    "MN": "Minnesota",
    "MS": "Mississippi",
    "MO": "Missouri",
    "MT": "Montana",
    "NE": "Nebraska",
    "NV": "Nevada",
    "NH": "New Hampshire",
    "NJ": "New Jersey",
    "NM": "New Mexico",
    "NY": "New York",
    "NC": "North Carolina",
    "ND": "North Dakota",
    "OH": "Ohio",
    "OK": "Oklahoma",
    "OR": "Oregon",
    "PA": "Pennsylvania",
    "RI": "Rhode Island",
    "SC": "South Carolina",
    "SD": "South Dakota",
    "TN": "Tennessee",
    "TX": "Texas",
    "UT": "Utah",
    "VT": "Vermont",
    "VA": "Virginia",
    "WA": "Washington",
    "WV": "West Virginia",
    "WI": "Wisconsin",
    "WY": "Wyoming"
  };

  this.countries = {
    "": "Country",
    "USA": "United States of America",
    "AFG": "Afghanistan",
    "ALA": "\u00c5land",
    "ALB": "Albania",
    "DZA": "Algeria",
    "ASM": "American Samoa",
    "AND": "Andorra",
    "AGO": "Angola",
    "AIA": "Anguilla",
    "ATA": "Antarctica",
    "ATG": "Antigua and Barbuda",
    "ARG": "Argentina",
    "ARM": "Armenia",
    "ABW": "Aruba",
    "AUS": "Australia",
    "AUT": "Austria",
    "AZE": "Azerbaijan",
    "BHS": "Bahamas",
    "BHR": "Bahrain",
    "BGD": "Bangladesh",
    "BRB": "Barbados",
    "BLR": "Belarus",
    "BEL": "Belgium",
    "BLZ": "Belize",
    "BEN": "Benin",
    "BMU": "Bermuda",
    "BTN": "Bhutan",
    "BOL": "Bolivia",
    "BIH": "Bosnia and Herzegovina",
    "BWA": "Botswana",
    "BVT": "Bouvet Island",
    "BRA": "Brazil",
    "IOT": "British Indian Ocean Territory",
    "BRN": "Brunei Darussalam",
    "BGR": "Bulgaria",
    "BFA": "Burkina Faso",
    "BDI": "Burundi",
    "KHM": "Cambodia",
    "CMR": "Cameroon",
    "CAN": "Canada",
    "CPV": "Cape Verde",
    "CYM": "Cayman Islands",
    "CAF": "Central African Republic",
    "TCD": "Chad",
    "CHL": "Chile",
    "CHN": "China",
    "CXR": "Christmas Island",
    "CCK": "Cocos (Keeling) Islands",
    "COL": "Colombia",
    "COM": "Comoros",
    "COG": "Congo (Brazzaville)",
    "COD": "Congo (Kinshasa)",
    "COK": "Cook Islands",
    "CRI": "Costa Rica",
    "CIV": "C\u00f4te d'Ivoire",
    "HRV": "Croatia",
    "CUB": "Cuba",
    "CYP": "Cyprus",
    "CZE": "Czech Republic",
    "DNK": "Denmark",
    "DJI": "Djibouti",
    "DMA": "Dominica",
    "DOM": "Dominican Republic",
    "ECU": "Ecuador",
    "EGY": "Egypt",
    "SLV": "El Salvador",
    "GNQ": "Equatorial Guinea",
    "ERI": "Eritrea",
    "EST": "Estonia",
    "ETH": "Ethiopia",
    "FLK": "Falkland Islands",
    "FRO": "Faroe Islands",
    "FJI": "Fiji",
    "FIN": "Finland",
    "FRA": "France",
    "GUF": "French Guiana",
    "PYF": "French Polynesia",
    "ATF": "French Southern Lands",
    "GAB": "Gabon",
    "GMB": "Gambia",
    "GEO": "Georgia",
    "DEU": "Germany",
    "GHA": "Ghana",
    "GIB": "Gibraltar",
    "GRC": "Greece",
    "GRL": "Greenland",
    "GRD": "Grenada",
    "GLP": "Guadeloupe",
    "GUM": "Guam",
    "GTM": "Guatemala",
    "GGY": "Guernsey",
    "GIN": "Guinea",
    "GNB": "Guinea-Bissau",
    "GUY": "Guyana",
    "HTI": "Haiti",
    "HMD": "Heard and McDonald Islands",
    "HND": "Honduras",
    "HKG": "Hong Kong",
    "HUN": "Hungary",
    "ISL": "Iceland",
    "IND": "India",
    "IDN": "Indonesia",
    "IRN": "Iran",
    "IRQ": "Iraq",
    "IRL": "Ireland",
    "IMN": "Isle of Man",
    "ISR": "Israel",
    "ITA": "Italy",
    "JAM": "Jamaica",
    "JPN": "Japan",
    "JEY": "Jersey",
    "JOR": "Jordan",
    "KAZ": "Kazakhstan",
    "KEN": "Kenya",
    "KIR": "Kiribati",
    "PRK": "Korea, North",
    "KOR": "Korea, South",
    "KWT": "Kuwait",
    "KGZ": "Kyrgyzstan",
    "LAO": "Laos",
    "LVA": "Latvia",
    "LBN": "Lebanon",
    "LSO": "Lesotho",
    "LBR": "Liberia",
    "LBY": "Libya",
    "LIE": "Liechtenstein",
    "LTU": "Lithuania",
    "LUX": "Luxembourg",
    "MAC": "Macau",
    "MKD": "Macedonia",
    "MDG": "Madagascar",
    "MWI": "Malawi",
    "MYS": "Malaysia",
    "MDV": "Maldives",
    "MLI": "Mali",
    "MLT": "Malta",
    "MHL": "Marshall Islands",
    "MTQ": "Martinique",
    "MRT": "Mauritania",
    "MUS": "Mauritius",
    "MYT": "Mayotte",
    "MEX": "Mexico",
    "FSM": "Micronesia",
    "MDA": "Moldova",
    "MCO": "Monaco",
    "MNG": "Mongolia",
    "MNE": "Montenegro",
    "MSR": "Montserrat",
    "MAR": "Morocco",
    "MOZ": "Mozambique",
    "MMR": "Myanmar",
    "NAM": "Namibia",
    "NRU": "Nauru",
    "NPL": "Nepal",
    "NLD": "Netherlands",
    "ANT": "Netherlands Antilles",
    "NCL": "New Caledonia",
    "NZL": "New Zealand",
    "NIC": "Nicaragua",
    "NER": "Niger",
    "NGA": "Nigeria",
    "NIU": "Niue",
    "NFK": "Norfolk Island",
    "MNP": "Northern Mariana Islands",
    "NOR": "Norway",
    "OMN": "Oman",
    "PAK": "Pakistan",
    "PLW": "Palau",
    "PSE": "Palestine",
    "PAN": "Panama",
    "PNG": "Papua New Guinea",
    "PRY": "Paraguay",
    "PER": "Peru",
    "PHL": "Philippines",
    "PCN": "Pitcairn",
    "POL": "Poland",
    "PRT": "Portugal",
    "PRI": "Puerto Rico",
    "QAT": "Qatar",
    "REU": "Reunion",
    "ROU": "Romania",
    "RUS": "Russian Federation",
    "RWA": "Rwanda",
    "BLM": "Saint Barth\u00e9lemy",
    "SHN": "Saint Helena",
    "KNA": "Saint Kitts and Nevis",
    "LCA": "Saint Lucia",
    "MAF": "Saint Martin (French part)",
    "SPM": "Saint Pierre and Miquelon",
    "VCT": "Saint Vincent and the Grenadines",
    "WSM": "Samoa",
    "SMR": "San Marino",
    "STP": "Sao Tome and Principe",
    "SAU": "Saudi Arabia",
    "SEN": "Senegal",
    "SRB": "Serbia",
    "SYC": "Seychelles",
    "SLE": "Sierra Leone",
    "SGP": "Singapore",
    "SVK": "Slovakia",
    "SVN": "Slovenia",
    "SLB": "Solomon Islands",
    "SOM": "Somalia",
    "ZAF": "South Africa",
    "SGS": "South Georgia and South Sandwich Islands",
    "ESP": "Spain",
    "LKA": "Sri Lanka",
    "SDN": "Sudan",
    "SUR": "Suriname",
    "SJM": "Svalbard and Jan Mayen Islands",
    "SWZ": "Swaziland",
    "SWE": "Sweden",
    "CHE": "Switzerland",
    "SYR": "Syria",
    "TWN": "Taiwan",
    "TJK": "Tajikistan",
    "TZA": "Tanzania",
    "THA": "Thailand",
    "TLS": "Timor-Leste",
    "TGO": "Togo",
    "TKL": "Tokelau",
    "TON": "Tonga",
    "TTO": "Trinidad and Tobago",
    "TUN": "Tunisia",
    "TUR": "Turkey",
    "TKM": "Turkmenistan",
    "TCA": "Turks and Caicos Islands",
    "TUV": "Tuvalu",
    "UGA": "Uganda",
    "UKR": "Ukraine",
    "ARE": "United Arab Emirates",
    "GBR": "United Kingdom",
    "UMI": "United States Minor Outlying Islands",
    "URY": "Uruguay",
    "UZB": "Uzbekistan",
    "VUT": "Vanuatu",
    "VAT": "Vatican City",
    "VEN": "Venezuela",
    "VNM": "Vietnam",
    "VGB": "Virgin Islands, British",
    "VIR": "Virgin Islands, U.S.",
    "WLF": "Wallis and Futuna Islands",
    "ESH": "Western Sahara",
    "YEM": "Yemen",
    "ZMB": "Zambia",
    "ZWE": "Zimbabwe"
  };

}



/** WEBPACK FOOTER **
 ** ./src/app/ecourse/registration/registration.service.js
 **/